/**
 * Canvas Header
 * A homepage section's eyebrow and heading, on a slide canvas
 */

import styled from 'styled-components';
import { colors } from '@config/colors';
import { typography } from '@config/typography';

/* The homepage sections' own header type (demo-section.tsx, how-section.tsx)
   at slide size, in canvas pixels (`SlideCanvas`). */

export const CanvasEyebrow = styled.div`
  font-family: ${typography.fontFamily.small};
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: ${colors.brand.exxxtraDark};
`;

export const CanvasHeading = styled.h2`
  font-family: 'Poppins', ${typography.fontFamily.heading};
  font-size: 62px;
  font-weight: 300;
  line-height: 1.1;
  letter-spacing: -0.02em;
  color: ${colors.neutral.extraDark};
  margin: 14px 0 0;
  white-space: nowrap;
`;

/** The coral How we build gives "next mom." */
export const CanvasAccent = styled.span`
  font-weight: 400;
  color: ${colors.accent.coral.dark};
`;
